import { Grid, TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import CustomTextField from "../../../components/customFields/CustomTextField";
import CustomMuiltiLineTextField from "../../../components/customFields/CustomMuiltiLineTextField";
import BlueOutlinedButton from "../../../components/customButtons/BlueOutlineButton";
import BlueMediumButton from "../../../components/customButtons/BlueMediumButton";
import {
  editLeaveRequest,
  handleFetchClassLeaveCalandar,
  
} from "../../testPrepDashboard/Api/DashboardApi";
import { useParams } from "react-router-dom";
import ErrorPopupScreen from "../../../components/customPopup/ErrorPopupScreen";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import "../../testPrepEnrolment/calendar.css";
export default function EditLeaveRequest({
  handleClose,
  selectedData,
  handleOpenSuccessPopup,
  setMessageTitle,
  setSubMessage,
}) {
  const userId = localStorage.getItem("userId");
  const { std_class_detail_id } = useParams();
  const [errors, setErrors] = useState({});
  const [changes, setChanges] = useState({});
  const [startDate, setStartDate] = useState(
    new Date(selectedData?.start_date)
  );

   

  const [endDate, setEnddate] = useState(new Date(selectedData?.end_date));

  const [reason, setReason] = useState(selectedData?.reason);
  const [openErrorPopup, setOpenErrorPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const [slotsData, setSlotsData] = useState([]);

  const handleFieldChange = (fieldName, value) => {
    setChanges((prevChanges) => ({
      ...prevChanges,
      [fieldName]: value,
    }));
  };

  // validate leave details
  const validateLeave = () => {
    const newErrors = {};


    if (!startDate) newErrors.startDate = "Start date is required";
  
    if (!endDate) newErrors.endDate = "End date is required";

    if (!reason) newErrors.reason = "Reason is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

// edit leave request

  const handleSubmitData = async () => {
    if (validateLeave()) {
      try {
        const response = await editLeaveRequest({
          ...changes,
          user_id: parseInt(userId),
          calender_arr:slotsData
      
        }, selectedData?.id);

        if (response.status === 200) {
          handleClose();
          setMessageTitle("Leave request updated successfully.");
          setSubMessage(
            "We’ve received your leave request and will process it shortly."
          );
          handleOpenSuccessPopup();
        } else {
          setErrorMessage(response?.message);
          handleOpenErrorPopup();
        }
      } catch (error) {
        setErrorMessage(error);
        handleOpenErrorPopup();
      }
    } else {
      console.log("Validation error");
    }
  };

  // error popup

  const handleOpenErrorPopup = () => {
    setOpenErrorPopup(true);
  };

  const handleCloseErrorPopup = () => {
    setOpenErrorPopup(false);
  };

  // available class slots  
  const handleClassLeaveCalandar = async () => {
    try {
      const response = await handleFetchClassLeaveCalandar({
        user_id: parseInt(userId),
        student_class_details_id: std_class_detail_id,
      });

      if (response.status === 200) {
        setSlotsData(response?.data);
      } else {
        setSlotsData([]);
      }
    } catch (error) {
      setSlotsData([]);
    }
  };

  useEffect(() => {
    handleClassLeaveCalandar();
  }, []);

  const formatDate = (date) => {
    return date.toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" });
    // gives YYYY-MM-DD in IST
  };

  // Only allow dates that have slots
  const filterDate = (date) => {
    const dateStr = formatDate(date);
    const dateObj = slotsData.find((d) => d.date === dateStr);

    return dateObj?.is_class === true;
  };

  // Highlight dates with available slots
  const customDayClass = (date) => {
    const dateStr = formatDate(date);
    const dateObj = slotsData.find((d) => d.date === dateStr);
 

    if (dateObj?.is_class === true) {
      return "react-datepicker__day--highlighted-pink"; // pink
    } else {
      return "react-datepicker__day--disabled"; // disabled
    }
  };

    // Highlight dates with available slots
  const customDayEndClass = (date) => {
    const dateStr = formatDate(date);
    const dateObj = slotsData.find((d) => d.date === dateStr);


    if (
      dateObj?.is_class === true &&
      dateObj?.date >= startDate?.toISOString().split("T")[0]
    ) {
      return "react-datepicker__day--highlighted-pink"; // pink
    } else {
      return "react-datepicker__day--disabled"; // disabled
    }
  };

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography
            color="#333333"
            fontFamily="Inter"
            fontSize="14px"
            lineHeight="100%"
            letterSpacing="0px"
            fontStyle="normal"
            mb={1}
            style={{ fontWeight: 400 }}
          >
            Start Date <span style={{ color: "#CE0E00" }}>*</span>
          </Typography>

          <DatePicker
            fullWidth
            selected={startDate}
            onChange={(date) => {
           
              setStartDate(date);
              handleFieldChange("start_date", date);
              setEnddate(null);
              handleFieldChange("end_date", null);
            }}
            filterDate={filterDate}
            dayClassName={customDayClass}
            dateFormat="dd - MM - yyyy"
            customInput={
              <CustomTextField
                fullWidth
                variant="outlined"
                borderColor="#E6E2F7"
                size="small"
                color="#9D0385"
                fontWeight={700}
                fontSize={13}
                error={!!errors.startDate}
                helperText={errors.startDate}
                InputProps={{
                  endAdornment: (
                    <CalendarTodayIcon
                      style={{ cursor: "pointer", fontSize: "1rem" }}
                    />
                  ),
                }}
              />
            }
          />
        </Grid>

        <Grid item xs={12}>
          <Typography
            color="#333333"
            fontFamily="Inter"
            fontSize="14px"
            lineHeight="100%"
            letterSpacing="0px"
            fontStyle="normal"
            mb={1}
            style={{ fontWeight: 400 }}
          >
            End Date <span style={{ color: "#CE0E00" }}>*</span>
          </Typography>

          <DatePicker
            fullWidth
            selected={endDate}
            onChange={(date) => {
              setEnddate(date);
              handleFieldChange("end_date", date);
            }}
            filterDate={filterDate}
            dayClassName={customDayEndClass}
            dateFormat="dd - MM - yyyy"
            customInput={
              <CustomTextField
                fullWidth
                variant="outlined"
                borderColor="#E6E2F7"
                size="small"
                color="#9D0385"
                fontWeight={700}
                fontSize={13}
                error={!!errors.endDate}
                helperText={errors.endDate}
                InputProps={{
                  endAdornment: (
                    <CalendarTodayIcon
                      style={{ cursor: "pointer", fontSize: "1rem" }}
                    />
                  ),
                }}
              />
            }
          />
        </Grid>

      
        <Grid item xs={12}>
          <Typography
            color="#333333"
            fontFamily="Inter"
            fontSize="14px"
            lineHeight="100%"
            letterSpacing="0px"
            fontStyle="normal"
            mb={1}
            style={{ fontWeight: 400 }}
          >
            Reason <span style={{ color: "#CE0E00" }}>*</span>
          </Typography>

          <CustomMuiltiLineTextField
            placeholder="Please Provide a reason for your leave"
            fontSize="14px"
            fullWidth
            rows={2}
            onChange={(e) => {
              setReason(e.target.value);
              handleFieldChange("reason", e.target.value);
            }}
            value={reason}
            error={!!errors.reason}
            helperText={errors.reason}
          />
        </Grid>

        <Grid item xs={12} container gap={1} justifyContent="center">
          <BlueOutlinedButton buttonTitle="Cancel" onClick={handleClose} />
          <BlueMediumButton
            buttonTitle="Submit Request"
            onClick={handleSubmitData}
          />
        </Grid>
      </Grid>

      <ErrorPopupScreen
        open={openErrorPopup}
        handleClose={handleCloseErrorPopup}
        subText={errorMessage}
        buttonTitle="Got It"
        maxWidth="xs"
      />
    </>
  );
}
